export default "__VITE_ASSET__8HI$0Ucq__"